import { SubPatient } from 'graphql/generated/hasura';
import { AccountInfo } from '../auth/context/AuthProvider';

export const mapChildAccount = (childAccounts: SubPatient[]): AccountInfo[] => {
  return childAccounts.map((account: SubPatient) => {
    return {
      id: account.id,
      name: `${account.firstName} ${account.lastName}`,
      avatarImage: account.profilePhoto,
      blockedAt: account.blocked_at,
      closedAt: account.account_closed_at,
      isVerify: !!account.child_fully_verified,
      isChild: true,
    };
  });
};
